/**
 * Convert a Foretry file path to a slug.
 *
 * @param {string} path
 */
export default (path = '') => {
  const file = path.substring(path.lastIndexOf('/') + 1)
  const slug = file.split('.')[0]

  return slug
}
